import React from 'react';
import './SkeletonLoader.css';

interface SkeletonLoaderProps {
  variant?: 'text' | 'rect' | 'circle';
  width?: string | number;
  height?: string | number;
  animation?: 'pulse' | 'shimmer';
  className?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ 
  variant = 'text', 
  width, 
  height, 
  animation = 'shimmer',
  className = ''
}) => {
  const style: React.CSSProperties = {};
  
  if (width) style.width = width;
  if (height) style.height = height;
  
  return (
    <div 
      className={`skeleton skeleton-${variant} skeleton-${animation} ${className}`}
      style={style}
    />
  );
};

// Specific skeleton components for news items
export const NewsItemSkeleton: React.FC = () => {
  return (
    <div className="news-item-skeleton">
      <div className="news-item-skeleton-content">
        <div className="news-item-skeleton-header">
          <div className="news-item-skeleton-title-section">
            {/* Image placeholder */}
            <div className="news-item-skeleton-image">
              <SkeletonLoader variant="rect" width="80px" height="60px" />
            </div>
            
            <div className="news-item-skeleton-text-content">
              {/* Title placeholders */}
              <div className="news-item-skeleton-title">
                <SkeletonLoader width="90%" height="18px" />
                <SkeletonLoader width="65%" height="18px" />
              </div>
              
              {/* Source placeholder */}
              <div className="news-item-skeleton-source">
                <SkeletonLoader width="120px" height="14px" />
              </div>
            </div>
          </div>
          
          <div className="news-item-skeleton-actions">
            {/* Button placeholders */}
            <SkeletonLoader variant="rect" width="70px" height="28px" />
            <SkeletonLoader variant="rect" width="24px" height="24px" />
          </div>
        </div>
        
        <div className="news-item-skeleton-meta">
          {/* Topic and date placeholders */}
          <SkeletonLoader width="80px" height="20px" />
          <SkeletonLoader width="100px" height="14px" />
        </div>
      </div>
    </div>
  );
};

// Component to show multiple skeleton items
export const NewsItemsSkeletonList: React.FC<{ count?: number }> = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <NewsItemSkeleton key={index} />
      ))}
    </>
  );
};

export default SkeletonLoader;